import { Reducer } from 'redux';
import { ItineraryStatus } from '../../../models/itinerary';
import { ActionTypes } from '../../constants/action-types';
import { ItineraryReceiveAction } from '../itinerary/types';
import {
  ConfirmDialogReducerActions,
  ToggleConfirmDialogAction,
  UserNoteChangeAction,
} from './types';

export interface ComfirmDialogState {
  open: boolean;
  note: string;
  itineraryStatus: ItineraryStatus;
  loading: boolean;
  showEmailSent: boolean;
  showError: boolean;
}

export const confirmDialogInitialState: ComfirmDialogState = {
  open: false,
  note: '',
  itineraryStatus: 'New',
  loading: false,
  showEmailSent: false,
  showError: false,
};

export const ConfirmDialogReducer: Reducer<
  ComfirmDialogState,
  ConfirmDialogReducerActions
> = (
  state = confirmDialogInitialState,
  action: ConfirmDialogReducerActions,
  ): ComfirmDialogState => {
    switch (action.type) {
      case ActionTypes.TOGGLE_CONFIRM_DIALOG:
        const values = action as ToggleConfirmDialogAction;
        return {
          ...state,
          open: values.open,
          itineraryStatus: values.itineraryStatus,
          showError: false,
        };
      case ActionTypes.USER_NOTE_CHANGE:
        const note = (action as UserNoteChangeAction).note;
        return { ...state, note };
      case ActionTypes.ITINERARY_REQUEST_CHANGES_REQUEST:
        return { ...state, loading: true }; // test the loading state?
      case ActionTypes.ITINERARY_REQUEST_CHANGES_RESPONSE:
        return { ...state, showEmailSent: true };
      case ActionTypes.ITINERARY_REQUEST_CHANGES_ERROR:
        return { ...state, loading: false, showError: true };
      case ActionTypes.ITINERARY_GET_RECEIVE:
      case ActionTypes.ITINERARY_INTL_GET_RECEIVE:
        const data = (action as ItineraryReceiveAction).data;
        const status = data && data.status;
        if (status === 'New') {
          const searchParams = new URLSearchParams(window.location.search);
          const requestAction = getRequestAction(searchParams.get('action') || '');
          if (requestAction) {
            return {
              ...state,
              open: true,
              itineraryStatus: requestAction,
              showError: false,
            };
          }
        }
        return { ...state };
      default:
        return { ...state };
    }
  };

const getRequestAction = (action: string): ItineraryStatus | undefined => {
  switch (action.toUpperCase().trim()) {
    case 'ACCEPT':
      return 'Accepted';
    case 'DECLINE':
      return 'Rejected';
    default:
      return undefined;
  }
}
